function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M31.457 34.781l-30.09-8.526c-1.093-.31-1.47-1.713-.678-2.527L22.482 1.332c.792-.814 2.158-.426 2.46.696l8.296 30.923c.301 1.123-.688 2.14-1.781 1.83m8.305-.764l8.296-30.922c.302-1.123 1.668-1.51 2.46-.696L72.31 24.795c.792.813.415 2.217-.678 2.527l-30.09 8.526c-1.093.31-2.082-.707-1.78-1.83",
  fill: "#FBAD00",
  fillRule: "evenodd"
});

function SvgTriangles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 73 36"
  }, props), _ref);
}

export default SvgTriangles;